import * as React from 'react';
import { PDFNoteCode } from '../../../../../pages/notes/models/PDFNoteCode';
import { PDFNoteCodeTypeVals } from '../../../../../helpers/mapping/PDFNoteCodeTypeVals';
import { WorkflowsVals } from '../../../../../helpers/mapping/Workflows';
import { services } from '../../../../../services';
import { useBackgroundPromiseEffectByCondition } from '../../../../../helpers/hooks/useBackgroundPromiseEffectByCondition';

export function isTsWorkflow(workflowId?: number): boolean {
    return workflowId === WorkflowsVals.TechSpecsApproval || workflowId === WorkflowsVals.TechSpecsChangesApproval;
}

export function useNoteCodes(workflowId?: number) {
    const isTsNote = isTsWorkflow(workflowId);
    const isExecutive = workflowId === WorkflowsVals.Executive;
    const [codes, setCodes] = React.useState<PDFNoteCode[]>([]);

    useBackgroundPromiseEffectByCondition(
        () => !isTsNote && codes.length === 0,
        () => services.pDFNoteCodeService.fetch({
            Sorts: [{ Field: 'Id', Desc: false }],
            ...(isExecutive
                ? { codeTypeIds: [PDFNoteCodeTypeVals.Executive] }
                : { codeTypeIds: [PDFNoteCodeTypeVals.Ordinary] }),
        }),
        (res: PDFNoteCode[]) => setCodes(res),
        [isTsNote, isExecutive]
    );

    return { codes, isExecutive, showCriticalCode: !isTsNote };
}
